import request from '@/utils/request'
import { IWorkgroup } from '@/store/models/tableEdit.model'

export interface voteInfo {
    id: string
    techAbstract: boolean
    techContext: string
    imageInfo: string
    techTitle?: string
    techUrl?: string
    workGroup?: IWorkgroup
}

export interface voteData {
    id?: string
    isApproval?: boolean
    imageInfo?: string
    remark?: string
    techContext?: string
    techUrl?: string
    workGroupId?: number
    voteType?: number
}
export interface reportList {
    totalElements: number
    content: any[]
}

// 投票
export const addVote = (data: voteData): Promise<string> => request<string>({
    method: 'POST',
    url: '/api/pangooITMT/tech/news',
    data
})

// 获取发起投票的技术信息
export const getTechInfo = (params: {
    id: string
}): Promise<voteInfo> => request<voteInfo>({
    method: 'GET',
    url: `/api/pangooITMT/tech/news/${params.id}`,
})

// 反馈信息
export const faceBack = (data: voteData): Promise<string> => request<string>({
    method: 'POST',
    url: '/api/pangooITMT/tech/news/faceBack',
    data
})

// 获取技术信息列表
export const getTechInfoList = (params: {
    pageNo: number
    pageSize: number
    workGroupId?: number
}): Promise<reportList> => request<reportList>({
    method: 'GET',
    url: '/api/pangooITMT/tech/news',
    params
})

// 获取反馈列表
export const getFaceBackList = (params: {
    id: number
}): Promise<any[]> => request<any[]>({
    method: 'GET',
    url: `/api/pangooITMT/tech/news/faceBack/${params.id}`,
})

// 获取汇总报告
export const getFaceBackReport = (params: {
    startDate: string
    endDate?: string
}): Promise<any[]> => request<any[]>({
    method: 'GET',
    url: '/api/pangooITMT/tech/news/report',
    params
})
